import React from "react";
import Activity from "../../Activity";

const Events = ({ accountid, t }) => {
  return <Activity accountid={accountid} t={t} isInstanceTabElement />;
};

export default Events;
